(function () {
  // Read rules injected by gwp-auto-gift.liquid
  var rulesEl = document.getElementById("gwp-rules-data");
  if (!rulesEl) return;

  var rules = [];
  try { rules = JSON.parse(rulesEl.textContent); } catch (e) { return; }
  rules = rules.filter(function (r) { return r.enabled !== false; });
  if (!rules.length) return;

  // ── cart helpers ──────────────────────────────────────────────────────────

  function getCart() {
    return fetch("/cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.json(); });
  }

  function addItem(variantId, qty, props) {
    return fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty, properties: props }] }),
    });
  }

  function setQty(lineKey, qty) {
    return fetch("/cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: lineKey, quantity: qty }),
    });
  }

  // ── rule evaluation ───────────────────────────────────────────────────────

  // ── landing-page discount suppression ─────────────────────────────────────
  // The pick-a-block page arms this flag the moment it reveals a code, and
  // stamps it with the code's own expiry.
  //
  // While it is live, every rule reports its condition as UNMET. That is the
  // whole trick: we don't fight the reconciler, we tell it the truth it
  // already knows how to act on. Its existing "!should && existing" branch
  // then removes the gift and clears the dismissed state, and once the code
  // expires the condition goes true again and the gift comes back on its own.
  //
  // Why it matters: the gift is a $0 line only because of the "Free Busy
  // Board" BXGY, and that BXGY cannot combine with an order discount. Leave
  // the board in the cart alongside a block code and it stops being free —
  // the customer gets charged $60 for it.

  var BLOCK_KEY = "sw_block_active";

  function blockCodeLive() {
    try {
      var r = JSON.parse(localStorage.getItem(BLOCK_KEY) || "null");
      if (!r || !r.until) return false;
      if (Date.now() >= r.until) {         // expired — tidy up and carry on
        localStorage.removeItem(BLOCK_KEY);
        return false;
      }
      return true;
    } catch (e) {
      return false;                        // private mode, quota, bad JSON
    }
  }

  function conditionMet(rule, cart) {
    if (blockCodeLive()) return false;

    switch (rule.conditionType) {
      case "subtotal_min":
        // conditionValue is in dollars — cart uses cents
        return cart.items_subtotal_price >= Math.round(rule.conditionValue * 100);

      case "product_in_cart":
        return cart.items.some(function (item) {
          return !isGift(item) && String(item.product_id) === String(rule.conditionValue);
        });

      case "any_product_in_cart":
        // conditionValue is an array of variant IDs — gift fires if ANY are in the cart
        var ids = [].concat(rule.conditionValue).map(String);
        return cart.items.some(function (item) {
          return !isGift(item) && ids.indexOf(String(item.variant_id)) !== -1;
        });

      case "collection_in_cart":
        // conditionValue is an array of product IDs rendered by Liquid from a collection
        var collectionIds = [].concat(rule.conditionValue).map(String);
        return cart.items.some(function (item) {
          return !isGift(item) && collectionIds.indexOf(String(item.product_id)) !== -1;
        });

      default:
        return false;
    }
  }

  function isGift(item) {
    return !!((item.properties || {})["_gwp"]);
  }

  function giftLineForRule(cart, ruleId) {
    for (var i = 0; i < cart.items.length; i++) {
      if ((cart.items[i].properties || {})["_gwp"] === String(ruleId)) {
        return cart.items[i];
      }
    }
    return null;
  }

  // ── dismissed-gift tracking (sessionStorage) ─────────────────────────────
  // Tracks whether our script has ever added each gift this session.
  // If the gift disappears while the condition is still met, the customer
  // removed it intentionally — we mark it dismissed and stop re-adding.
  // The dismissed state clears when the condition goes unmet (cart changes
  // enough to drop below threshold), so a fresh trigger offers the gift again.

  var SS_KEY = "gwp_state";

  function getGwpState() {
    try { return JSON.parse(sessionStorage.getItem(SS_KEY) || "{}"); } catch (e) { return {}; }
  }

  function setGwpState(ruleId, state) {
    try {
      var s = getGwpState();
      if (state === null) { delete s[String(ruleId)]; } else { s[String(ruleId)] = state; }
      sessionStorage.setItem(SS_KEY, JSON.stringify(s));
    } catch (e) {}
  }

  // ── reconciler ────────────────────────────────────────────────────────────

  var busy = false;
  var queued = false;

  function reconcile() {
    if (busy) { queued = true; return; }
    busy = true;
    queued = false;

    getCart().then(function (cart) {
      var chain = Promise.resolve();
      var madeChanges = false;
      var state = getGwpState();

      // For each rule: add, remove, or fix quantity
      rules.forEach(function (rule) {
        var rid = String(rule.id);
        var existing = giftLineForRule(cart, rule.id);
        var should = conditionMet(rule, cart);

        if (should && !existing) {
          if (state[rid] === "dismissed") {
            // customer removed it — respect their choice
          } else if (state[rid] === "added") {
            // we added it but it's gone — customer removed it
            setGwpState(rule.id, "dismissed");
          } else {
            // first time adding
            madeChanges = true;
            chain = chain.then(function () {
              return addItem(rule.giftVariantId, rule.giftQuantity, { "_gwp": rid })
                .then(function () { setGwpState(rid, "added"); })
                .catch(function () {});
            });
          }
        } else if (!should && existing) {
          madeChanges = true;
          setGwpState(rule.id, null);
          chain = chain.then(function () {
            return setQty(existing.key, 0).catch(function () {});
          });
        } else if (!should && !existing) {
          // condition not met and gift not in cart — clear dismissed state so
          // the gift can be re-offered if the customer re-triggers the condition
          setGwpState(rule.id, null);
        } else if (should && existing && existing.quantity !== rule.giftQuantity) {
          madeChanges = true;
          chain = chain.then(function () {
            return setQty(existing.key, rule.giftQuantity).catch(function () {});
          });
        }
      });

      // Remove orphaned gifts (rule deleted but item still in cart)
      var validIds = {};
      rules.forEach(function (r) { validIds[String(r.id)] = true; });
      cart.items.forEach(function (item) {
        if (!isGift(item)) return;
        var rid = (item.properties || {})["_gwp"];
        if (!validIds[rid]) {
          madeChanges = true;
          chain = chain.then(function () {
            return setQty(item.key, 0).catch(function () {});
          });
        }
      });

      return chain.then(function () { return madeChanges; });
    })
    .then(function (madeChanges) {
      // Only notify theme to re-render if the cart actually changed
      if (!madeChanges) return;
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      document.dispatchEvent(new CustomEvent("cart:updated"));
      if (window.PUB_SUB_EVENTS && window.publish) {
        try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, {}); } catch (e) {}
      }
    })
    .catch(function () {})
    .then(function () {
      busy = false;
      if (queued) setTimeout(reconcile, 0);
    });
  }

  // ── intercept cart mutations ──────────────────────────────────────────────

  var debounce;
  function schedule() {
    clearTimeout(debounce);
    debounce = setTimeout(reconcile, 300);
  }

  function isCartMutation(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url || ""));
  }

  // Patch fetch
  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === "string" ? input : (input || {}).url;
    var p = _fetch.apply(window, arguments);
    if (isCartMutation(url)) p.then(schedule, schedule);
    return p;
  };

  // Patch XHR
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    this._gwpWatch = isCartMutation(url);
    return _open.apply(this, arguments);
  };
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this._gwpWatch) this.addEventListener("loadend", schedule);
    return _send.apply(this, arguments);
  };

  // Run on load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", reconcile);
  } else {
    reconcile();
  }
})();